export function responseErrorRedirectInterceptor(error: unknown): unknown {
    if (typeof error !== 'object' || error === null) {
        return;
    }

    if (
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'status' does not exist on type 'object'.
        error.status === 403 &&
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type 'object'.
        error.data &&
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type 'object'.
        error.data.type &&
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type 'object'.
        error.data.type === 'csrf_error'
    ) {
        /**
         * Reload the page when we encounter a 401 OR CSRF error,
         * since the CSRF error probably means the session has expired.
         */
        window.location.reload();
    }

    return Promise.reject(error);
}
